import React, {memo, useEffect, useState} from 'react';
import {View, TouchableOpacity, Platform, Text, Pressable} from 'react-native';

import {StyleSheet} from 'react-native';

import {colorPalette} from '../../../core/config/color.config';
import {RNEText} from '../../components';

import useStores from '../../stores/useStores';

import {Photo} from '../../server/types/user.types';
import {
  ConsultationRequestResBody,
  ConsultationStatusEnum,
} from '../../server/types/consultation.types';

import ConsultationPhoto from './ConsultationPhoto';
import ConsultationStatus from './ConsultationStatus';
import {width, height, totalSize} from 'react-native-dimension';

import {formatToMessageTime} from '../../utils/date.utils';
import {getFullName} from '../../utils/common.utils';
import ArchiveIcon from '../../../assets/icons/svg/download.svg';
import RadioButton from '../../components/RadioButtons/RadionButtons.native';

interface ConsultationListItemHistoryProps {
  item: ConsultationRequestResBody;
  onPress?: () => void;
  onEnableRadioButtons: (boolean) => void;
  showRadioButtons: boolean;
  onRadioSelected: (id) => void;
  selectedRadio: String[];
  isArchiveConfirmModalVisible: boolean;
  setIsArchiveConfirmModalVisible: (value) => void;
  setSingleArchiveSelection: (item) => void;
  selectedIds: any;
}

const ConsultationListItemHistory = (
  props: ConsultationListItemHistoryProps,
) => {
  const {authStore} = useStores();

  const [displayName, setDisplayName] = useState('');
  const [displayPhoto, setDisplayPhoto] = useState<Photo>();
  const [statusByPatient, setStatusByPatient] = useState(false);

  const updateDisplayNameByStatus = () => {
    if (props.item.subject) {
      switch (props.item.status) {
        case ConsultationStatusEnum.PENDING:
          // setDisplayName(
          //   `"Patient ${props.item.subject.patientId
          //     .substring(0, 6)
          //     .toUpperCase()}"`,
          // );

          setDisplayName(getFullName(props.item.subject.humanName));

          break;

        case ConsultationStatusEnum.CANCELLED:
          // setDisplayName(
          //   `"Patient ${props.item.subject.patientId
          //     .substring(0, 6)
          //     .toUpperCase()}"`,
          // );
          setDisplayName(getFullName(props.item.subject.humanName));

          break;

        case ConsultationStatusEnum.DECLINED:
          // setDisplayName(
          //   `"Patient ${props.item.subject.patientId
          //     .substring(0, 6)
          //     .toUpperCase()}"`,
          // );
          setDisplayName(getFullName(props.item.subject.humanName));

          break;

        case ConsultationStatusEnum.ONGOING:
          // setDisplayName(
          //   `${props.item.subject.humanName.given[0]} ${props.item.subject.humanName.family}`,
          // );
          setDisplayName(getFullName(props.item.subject.humanName));

          break;

        case ConsultationStatusEnum.COMPLETED:
          // setDisplayName(
          //   `${props.item.subject.humanName.given[0]} ${props.item.subject.humanName.family}`,
          // );
          setDisplayName(getFullName(props.item.subject.humanName));

          break;

        case ConsultationStatusEnum.ARCHIVED:
          // setDisplayName(
          //   `${props?.item?.subject?.humanName?.given[0] || 'N/A'} ${props?.item?.subject?.humanName?.family || ''}`,
          // );
          setDisplayName(getFullName(props.item.subject.humanName));

          break;

        default:
          break;
      }
      setDisplayPhoto(props.item.subject.photo);
    } else {
      setDisplayName('-');
    }
  };

  useEffect(() => {
    switch (authStore.userRole) {
      case 'patient':
        setStatusByPatient(
          authStore.auth?.user.userId === props.item?.modifiedBy,
        );

        if (props.item.performer) {
          setDisplayName(
            `Dr. ${props.item.performer.humanName.given[0]} ${props.item.performer.humanName.family}`,
          );
          setDisplayPhoto(props.item.performer.photo);
        } else {
          setDisplayName('Deleted Profile');
        }
        break;

      case 'practitioner':
        updateDisplayNameByStatus();
        setStatusByPatient(
          !(authStore.auth?.user.userId === props.item?.modifiedBy),
        );
        break;

      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.userRole, props]);

  return (
    <TouchableOpacity
      activeOpacity={0.75}
      onPress={
        props.showRadioButtons
          ? () => props.onRadioSelected(props.item.serviceRequestId)
          : props.onPress
      }
      onLongPress={() => {
        if(authStore.userRole === 'practitioner'){
          props.onEnableRadioButtons(true);
        }
      }}
      delayLongPress={500}
      style={{padding:totalSize(0), paddingTop:0, paddingBottom:0}}>
      <View style={[styles.mainContainer, props.showRadioButtons && {flexDirection: 'row'}]}>
        <View>
          {props.showRadioButtons && (
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                marginLeft: totalSize(0.5),
              }}>
              <RadioButton
                selected={props.selectedIds.includes(
                  props.item.serviceRequestId,
                )}
                onPress={() =>
                  props.onRadioSelected(props.item.serviceRequestId)
                }
                color={'#FF9800'}
                selectedColor={'#2E1A73'}
              />
            </View>
          )}
        </View>
        <View
          style={[
            styles.root,
            props.showRadioButtons
              ? {paddingLeft: 0, gap: width(1)}
              : {gap: width(1), justifyContent: 'space-between', paddingRight: 0},
          ]}>
          {/* <View
            style={[
              { flexDirection: 'row', alignItems: 'center',  },
              props.showRadioButtons ? { gap: 10 } : { gap: 20 } // add gap only if showRadioButtons is false
            ]}
          > */}
          <View style={styles.photo}>
            <ConsultationPhoto photo={displayPhoto} forConsultationList={true} />
          </View>

          <View style={styles.message}>
            <View>
              <RNEText
                label={displayName}
                color="blackLight"
                // weight="600"
                numberOfLines={1}
                ellipsizeMode="tail"
                style={[
                  {fontFamily: 'Quicksand-Bold', fontSize: totalSize(1.6)},
                ]}
              />
            </View>

            <View
              style={{
                marginTop: Platform.OS === 'ios' ? height(0.5) : height(0.5),
              }}>
              <RNEText
                label={formatToMessageTime(new Date(props.item.modifiedOn))}
                color="#81add0"
                variant="button"
                // weight="400"
                numberOfLines={2}
                ellipsizeMode="tail"
                style={[{fontFamily: 'Quicksand-Regular'}]}
              />
            </View>
            <View>
              <View style={styles.statusContainer}>
                <ConsultationStatus
                  consultationStatus={props.item.status}
                  procedureStatus={props.item.procedure?.status}
                  isActionByPatient={statusByPatient}
                />
              </View>
            </View>
          </View>
          {/* <View style={{display:'flex', alignItems:'flex-end', backgroundColor:'yellow'}}> */}

          {authStore.userRole === 'practitioner' && (
            <Pressable
              onPress={() => {
                props.setSingleArchiveSelection(props.item);
                props.setIsArchiveConfirmModalVisible(true);
              }}
              disabled={props.showRadioButtons}
              style={!props.showRadioButtons ? {marginLeft: 'auto', justifyContent:'center'} : {justifyContent:'center'}}>
              <View
                style={[
                  styles.container,
                  styles.archiveContainer,
                  props.showRadioButtons && {
                    backgroundColor: 'gray',
                    borderColor: 'gray',
                  },
                ]}>
                <View style={styles.btnContainer}>
                  <Text style={styles.btnTxtStyle}>Archive</Text>
                </View>
              </View>
            </Pressable>
          )}

          {/* </View> */}
        </View>
        {/* </View> */}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    display: 'flex',
    // flexDirection: 'row',
    gap: totalSize(2),
    alignItems: 'center',
  },
  root: {
    // flex: 1,
    display: 'flex',
    flexDirection: 'row',
    // paddingHorizontal: totalSize(1),
    // paddingVertical: totalSize(1.2),
    paddingHorizontal: totalSize(1.5),
    paddingVertical: totalSize(2),
    width: width(100),
    borderBottomWidth: 1,
    borderBottomColor: colorPalette.light,
  },
  photo: {},
  message: {
    flex:1,
    paddingHorizontal: width(3.5),
  },
  statusContainer: {
    width: width(16),
    justifyContent: 'center',
    marginTop: totalSize(0.5),
  },
  status: {
    borderRadius: 100,
    backgroundColor: colorPalette.accent,
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  button: {
    backgroundColor: '#1E9CE4', // blue background
    borderRadius: 30, // pill shape
    paddingVertical: 10,
    paddingHorizontal: 20,
    alignSelf: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.15,
    shadowOffset: {width: 0, height: 2},
    shadowRadius: 4,
    elevation: 3,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: 6,
  },
  text: {
    color: '#fff',
    fontSize: 15,
    fontWeight: '500',
    textTransform: 'lowercase', // matches your screenshot "archive"
  },
  archivebutton: {
    backgroundColor: '#1E9CE4',
    borderRadius: 30, // pill shape
    paddingVertical: 8,
    paddingHorizontal: 4,
    alignSelf: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: {width: 0, height: 2},
    shadowRadius: 3,
    elevation: 3,
  },
  archivecontent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  archivetext: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '500',
    marginLeft: 6,
  },
  container: {
    borderWidth: totalSize(0.2),
    padding: totalSize(1.5),
    paddingVertical: totalSize(0.7),
    paddingHorizontal: totalSize(1.2),
    borderRadius: totalSize(5),
    alignSelf: 'flex-end',
    alignContent: 'flex-end',
    marginRight: totalSize(1.2)
  },
  archiveContainer: {
    borderColor: '#3FB4E6',
    backgroundColor: '#3FB4E6',
  },
  btnContainer: {
    minWidth: width(12),
    maxWidth: width(12),
  },
  btnTxtStyle: {
    textAlign: 'center',
    color: colorPalette.white,
    fontFamily: 'Quicksand-Bold',
    fontSize: totalSize(1.3),
  },
});

export default memo(ConsultationListItemHistory);
